<template>
  <div class="fx-row-center pagination-box">
    <div class="box-left">
      <el-pagination
        @current-change="handleCurrentChange"
        background
        :current-page="currentPage"
        :page-count="pageCount"
        layout="prev, pager, next"
      ></el-pagination>
    </div>
    <div class="fx-row-around box-right">
      <div class="page-count">共{{pageCount}}页</div>
      <div class="page-to">
        到第
        <el-input-number
          :controls="false"
          v-model="inputPage"
          :min="1"
          :max="pageCount"
          class="page-to-input"
          type="text"
        />页
      </div>
      <div class="page-btn">
        <el-button @click="pageTo" type="info" plain size="mini">确定</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pageCount: {
      type: Number
    },
    currentPage: {
      type: Number
    }
  },
  data() {
    return {
      inputPage: 0
    };
  },
  watch: {
  },
  methods: {
    handleCurrentChange(val) {
      this.$emit("current-change", val);
    },
    pageTo() {
      if(this.inputPage > this.pageCount) {
        this.$message.error('您搜索的页数不存在');
        return;
      }
      this.$emit("current-change", this.inputPage);
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-input__inner {
  height: 28px;
  line-height: 28px;
}
/deep/ .el-input-number.is-without-controls .el-input__inner {
  padding-left: 5px;
  padding-right: 5px;
}
.pagination-box {
  padding: 20px 0px;
  .box-left {
  }
  .box-right {
    .page-count {
      margin: 0px 20px;
      margin-right: 0px;
    }
    .page-to {
      margin: 0px 10px;
      .page-to-input {
        border-radius: 4px;
        margin-right: 5px;
        width: 50px;
        &:focus {
          outline: none;
        }
      }
    }
    .page-btn {
      width: 30px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pagination/pagination.vue